import { makeStyles } from "tss-react/mui"
import { Grid, Link, Typography } from "@mui/material"
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"

const PROD_LINK = "https://app.facilitynet.dk"

const useStyles = makeStyles()((theme) => ({
    container: {
        background: theme.palette.tailwind.slate[700],
        color: theme.palette.tailwind.red[300],
        textAlign: "center",
        padding: "1.25rem",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 1300,
    },
    infoIcon: {
        color: theme.palette.tailwind.red[300],
    },
    link: {
        color: theme.palette.tailwind.blue[300],
    },
}))
export function QaEnvWarning() {
    const { classes } = useStyles()

    return (
        <Grid
            container
            className={classes.container}
            alignItems="center"
            justifyContent="center"
            flexWrap="nowrap"
            gap=".5rem"
        >
            <FontAwesomeIcon icon={faInfoCircle} className={classes.infoIcon} />
            <Typography variant="body1">
                <LocalizedStrict id="qa-env-warning-part-one">
                    <>You are in QA environment. This is not intended for customers. Please use</>
                </LocalizedStrict>{" "}
                <Link href={PROD_LINK} className={classes.link}>
                    {PROD_LINK}
                </Link>{" "}
                <LocalizedStrict id="qa-env-warning-part-two">
                    <>instead.</>
                </LocalizedStrict>
            </Typography>
        </Grid>
    )
}
